import React from 'react';
import PropTypes from 'proptypes';

const LiabilityModal = ({
  closeModal, tripId, userId, documentId, checkDocumentsAccordionState,
}) => (
  <div>
    <div className="row">
      <button className="square-icon right" onClick={closeModal}>
        X
      </button>
    </div>
    <div className="resp-container">
      <iframe
        className="resp-iframe"
        title="release-liability"
        src={`https://givevolunteers.secure.force.com/pmtx/ReleaseLiabilityForm?oid=${tripId}&cid=${userId}&dId=${documentId}`}
      />
    </div>
    <div>
      <p className="center">Please scroll down to the bottom and sign the document.</p>
    </div>
    <div className="right">
      <button onClick={checkDocumentsAccordionState}>I&apos;ve completed the agreement</button>
      {/* <button onClick={props.closeModal}>Close</button> */}
    </div>
  </div>
);

LiabilityModal.propTypes = {
  checkDocumentsAccordionState: PropTypes.func.isRequired,
  userId: PropTypes.string.isRequired,
  tripId: PropTypes.string.isRequired,
  documentId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default LiabilityModal;
